import React from 'react';
import { render } from 'react-dom';
import App from './containers/App/App';
import { Provider } from 'react-redux';
import store from './containers/App/store';
import * as Sentry from '@sentry/browser';

Sentry.init({dsn: "https://84a8da3168f64284ae58e075493ddb8e@sentry.engrave.dev/5"});

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
